import { render, staticRenderFns } from "./FeatureSection.vue?vue&type=template&id=1e8b9672&scoped=true&"
import script from "./FeatureSection.vue?vue&type=script&lang=js&"
export * from "./FeatureSection.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSection.vue?vue&type=style&index=0&id=1e8b9672&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b9672",
  null
  
)

export default component.exports